module.exports = __webpack_public_path__ + "img/Frame2.4d5cabef.png";